/* global G */
import { curry } from 'lib/util'
import session from 'app/_shared/session'
import setStepTab, { SEARCH, SELECT } from 'app/_shared/events/setStepTab'
import excludeNotConfirmedForRoles
  from 'app/_shared/events/search/query/excludeNotConfirmedForRoles'
import find from 'lib/sequence/component/children/find'
import { hide } from 'lib/sequence/component/state/hidden'

const props = component => ({
  ...component[G.PROPS],
  ...component[G.STATE],
})

/**
 * Hides the back button found at the search step.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {boolean} hideButton          whether to hide the `btnBack` element
 */
const hideSearchStepBackButton = (module, hideButton) => {
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  const { device } = find(actionComponent)
  const { btnBack } = find(device)
  hide(btnBack, hideButton)
}

/**
 * Perform a device search based on the user's role and save it in the action component's state.
 *
 * @param {Function} searchFn           search function to be used
 * @param {boolean} [changeStepIfNoResults] when `true`, if there are no search results, changes the
 *                                      current step tab to `SEARCH`.
 * @type {(function(...[*]): (*))|*}
 */
const searchWithRequestCount = (searchFn, changeStepIfNoResults) =>
  curry(async (module, component, event) => {
    const { organisation } = session(module)
    const { limit } = props(component)

    const options = {
        filter: { installedAt: organisation.key({ wrap: true }[0]) },
        query: await excludeNotConfirmedForRoles(module, component, event),
      }

    const result = limit
      ? await searchFn('defaultWithRequestCount', module, component, { ...event.detail, ...options })
      : null

    const data = result?.data || result

    hideSearchStepBackButton(module, false)
    if (changeStepIfNoResults && (!limit || !data?.length)) {
      await setStepTab(SEARCH, 'device')(module, component, event)
      hideSearchStepBackButton(module, true)
    }
    await module[G.ADAPTER][G.UI].update(module)

    return result
  })

export default searchWithRequestCount
